var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutProduitHM", {
        ref: "modalAjoutProduit",
        attrs: {
          produit: _vm.produitSelectionne,
          tarif: _vm.tarifSelectionne,
          paramModale: _vm.paramModale
        },
        on: {
          "produit-modifie": function($event) {
            return _vm.majListeProduit($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            ref: "barreFiltres",
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            ref: "barreActions",
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "card table-scroll height-responsive-100" },
            [
              _c(
                "table",
                {
                  staticClass:
                    "table table-bordered table-sm text-center table-header"
                },
                [
                  _vm._m(0),
                  _c("thead", [
                    _c(
                      "th",
                      {
                        staticClass: "watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("fam")
                          }
                        }
                      },
                      [
                        _vm._v("Fam."),
                        _vm.afficheIconeTri("fam")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "aligner-gauche watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("ingredient")
                          }
                        }
                      },
                      [
                        _vm._v("Ingrédient"),
                        _vm.afficheIconeTri("ingredient")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "aligner-gauche watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("designation")
                          }
                        }
                      },
                      [
                        _vm._v("Désignation"),
                        _vm.afficheIconeTri("designation")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("fournisseur")
                          }
                        }
                      },
                      [
                        _vm._v("Fournisseur"),
                        _vm.afficheIconeTri("fournisseur")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("marque")
                          }
                        }
                      },
                      [
                        _vm._v("Marque"),
                        _vm.afficheIconeTri("marque")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("reference")
                          }
                        }
                      },
                      [
                        _vm._v("Référence"),
                        _vm.afficheIconeTri("reference")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "watchMe",
                        on: {
                          click: function($event) {
                            return _vm.trierListe("prix", true)
                          }
                        }
                      },
                      [
                        _vm._v("P.U."),
                        _vm.afficheIconeTri("prix")
                          ? _c("i", { class: _vm.iconeSensTri })
                          : _vm._e()
                      ]
                    ),
                    _c("th", [_vm._v("PCB")]),
                    _c("th", [_vm._v("Allergènes")])
                  ])
                ]
              ),
              _c("div", { staticClass: "table-body" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-sm text-center" },
                  [
                    _vm._m(1),
                    _c(
                      "tbody",
                      _vm._l(_vm.listeProduits, function(produits, iProduit) {
                        return _c(
                          "tr",
                          {
                            key: iProduit,
                            class: [
                              {
                                "ligne-selectionnee":
                                  produits.produit.produitId ===
                                    _vm.idProduitSelectionne &&
                                  produits.tarif.tarifId ===
                                    _vm.idTarifSelectionne
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectionnerProduit(produits)
                              }
                            }
                          },
                          [
                            [
                              _c("td", [_vm._v(_vm._s(produits.famille.code))]),
                              !produits.ingredient
                                ? _c("td", { staticClass: "aligner-gauche" }, [
                                    _c("em", { staticClass: "text-warning" }, [
                                      _vm._v("Pas d'ingrédient")
                                    ])
                                  ])
                                : _c("td", { staticClass: "aligner-gauche" }, [
                                    _vm._v(
                                      " " + _vm._s(produits.ingredient) + " "
                                    )
                                  ]),
                              _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(
                                  _vm._s(
                                    produits.tarif.designation
                                      ? produits.tarif.designation
                                      : produits.produit.designation
                                  ) + " "
                                )
                              ]),
                              _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.nomFournisseur(
                                      produits.tarif.fournisseurId
                                    )
                                  )
                                )
                              ]),
                              _c("td", [_vm._v(_vm._s(produits.tarif.marque))]),
                              _c("td", [
                                _vm._v(_vm._s(produits.tarif.reference))
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(produits.tarif.pu) + " €")
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(produits.tarif.pcb) +
                                    " " +
                                    _vm._s(produits.produit.uc)
                                )
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatAllergene(produits.tarif)
                                    ) +
                                    " "
                                ),
                                _vm.sansAllergene(produits.tarif)
                                  ? _c("em", { staticClass: "error ml-2" }, [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-exclamation-triangle ligne-modifiee"
                                      }),
                                      _vm._v(" Aucun allergène sélectionné ")
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          ],
                          2
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "60" } }),
      _c("col", { attrs: { width: "260" } }),
      _c("col"),
      _c("col", { attrs: { width: "180" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "200" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "60" } }),
      _c("col", { attrs: { width: "260" } }),
      _c("col"),
      _c("col", { attrs: { width: "180" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "195" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }